import defaultEpicFilterOptions from "rtr-constants/defaultEpicFilterOptions";
import accessoryEpicFilterOptions from "rtr-constants/accessoryEpicFilterOptions";
import clothingEpicFilterOptions from "rtr-constants/clothingEpicFilterOptions";
import singleCategoryAccessoryEpicFilterOptions from "rtr-constants/singleCategoryAccessoryEpicFilterOptions";
import singleCategoryClothingEpicFilterOptions from "rtr-constants/singleCategoryClothingEpicFilterOptions";
import epicFilterReplacements from "rtr-constants/epicFilterReplacements";
import { UrlSignifiers } from "rtr-constants";

// TODO: It looks like we have a bunch of type-switching around grids. This means we can
// eventually refactor all this code such that we determine a grid "type" upfront.
// e.g. CarouselGrid, SingleCategoryAccessoryGrid, ClothingOnlyGrid, and then move logic
// around as we see fit.
export class GridEpicFilterOptions {
  constructor(accessoryOnly, path) {
    this.accessoryOnly = accessoryOnly;
    this.path = path;
  }

  addFilterByPath(newFilterOptions, epicFilter) {
    const pathInfo = this.getPathInfo();
    if (pathInfo) {
      if (pathInfo.isSingleCategoryClothing && singleCategoryClothingEpicFilterOptions[epicFilter]) {
        if (singleCategoryClothingEpicFilterOptions[epicFilter] !== UrlSignifiers.OMIT) {
          if (this.notClothingSpecialCase(epicFilter, pathInfo)) {
            newFilterOptions[epicFilter] = singleCategoryClothingEpicFilterOptions[epicFilter];
          }
        }
      } else if (pathInfo.isSingleCategoryAccessory && singleCategoryAccessoryEpicFilterOptions[epicFilter]) {
        if (singleCategoryAccessoryEpicFilterOptions[epicFilter] !== UrlSignifiers.OMIT) {
          newFilterOptions[epicFilter] = singleCategoryAccessoryEpicFilterOptions[epicFilter];
        }
      } else {
        if (pathInfo.isClothingOnly && clothingEpicFilterOptions[epicFilter]) {
          if (clothingEpicFilterOptions[epicFilter] !== UrlSignifiers.OMIT) {
            newFilterOptions[epicFilter] = clothingEpicFilterOptions[epicFilter];
          }
        } else if (pathInfo.isAccessoryOnly && accessoryEpicFilterOptions[epicFilter]) {
          if (accessoryEpicFilterOptions[epicFilter] !== UrlSignifiers.OMIT) {
            newFilterOptions[epicFilter] = accessoryEpicFilterOptions[epicFilter];
          }
        } else {
          if (defaultEpicFilterOptions[epicFilter] !== UrlSignifiers.OMIT) {
            newFilterOptions[epicFilter] = defaultEpicFilterOptions[epicFilter]; // default if no special pathInfo
          }
        }
      }
    } else {
      if (defaultEpicFilterOptions[epicFilter] !== UrlSignifiers.OMIT) {
        newFilterOptions[epicFilter] = defaultEpicFilterOptions[epicFilter]; // default if no pathInfo at all
      }
    }
    return newFilterOptions;
  }

  // get information about the path to send to facet-filters component
  isClothingOnlyGrid() {
    return !this.accessoryOnly && this.path.includes(UrlSignifiers.CLOTHING_ONLY.CLOTHING);
  }

  isCarouselGrid() {
    return this.path.startsWith(UrlSignifiers.CAROUSEL);
  }

  isSingleCategoryClothingGrid() {
    if (this.isCarouselGrid()) return false;
    return Object.values(UrlSignifiers.CLOTHING_ONLY.SINGLE_CATEGORY).some(e => this.path.includes(e));
  }

  isSingleCategoryAccessoryGrid() {
    return Object.values(UrlSignifiers.ACCESSORY_ONLY.SINGLE_CATEGORY).some(e => this.path.includes(e));
  }

  isBottomsGrid() {
    return this.path.includes(UrlSignifiers.CLOTHING_ONLY.SINGLE_CATEGORY.BOTTOM);
  }

  isSkirtsGrid() {
    return this.path.includes(UrlSignifiers.CLOTHING_ONLY.SINGLE_CATEGORY.SKIRT);
  }

  isTopGarmentsGrid() {
    return [
      UrlSignifiers.CLOTHING_ONLY.SINGLE_CATEGORY.TOP,
      UrlSignifiers.CLOTHING_ONLY.SINGLE_CATEGORY.KNIT,
      UrlSignifiers.CLOTHING_ONLY.SINGLE_CATEGORY.JACKET_COAT,
    ].some(e => this.path.includes(e));
  }

  getPathInfo() {
    return {
      isAccessoryOnly: this.accessoryOnly,
      isClothingOnly: this.isClothingOnlyGrid(),
      isSingleCategoryClothing: this.isSingleCategoryClothingGrid(),
      isSingleCategoryAccessory: this.isSingleCategoryAccessoryGrid(),
      isBottomsGrid: this.isBottomsGrid(),
      isSkirtsGrid: this.isSkirtsGrid(),
      isTopGarmentsGrid: this.isTopGarmentsGrid(),
    };
  }

  notClothingSpecialCase(epicFilter, pathInfo) {
    switch (epicFilter) {
      case "epicSleeve":
        // epic sleeve omitted from bottoms grid
        return !pathInfo.isBottomsGrid;
      case "epicLength":
        // epic length omitted from bottoms and top garments grids
        return !((pathInfo.isBottomsGrid && !pathInfo.isSkirtsGrid) || pathInfo.isTopGarmentsGrid);
      case "epicNeckline":
        // epic neckline omitted from bottoms grid
        return !pathInfo.isBottomsGrid;
      default:
        return true;
    }
  }
}

/*
Based on the status of feature flags, replaces the legacy filter options with filter options from Epic
These filter options should be passed as filterOptions props to any child component that renders filters
or otherwise makes use of filterOptions.
*/
export function replaceFilterOptions(filterOptions, accessoryOnly, path, featureFlags) {
  const newFilterOptions = { ...filterOptions };
  // add epic categories filter based on type of grid
  new GridEpicFilterOptions(accessoryOnly, path).addFilterByPath(newFilterOptions, "epicCategories");

  // iterate through epic feature flags
  for (const [flag, valueMap] of Object.entries(epicFilterReplacements)) {
    if (featureFlags[flag]) {
      const dorothyFilter = valueMap["dorothyFilter"];
      const epicFilter = valueMap["epicFilter"];

      // remove dorothy filter
      delete newFilterOptions[dorothyFilter];
      // add epic filter based on type of grid
      new GridEpicFilterOptions(accessoryOnly, path).addFilterByPath(newFilterOptions, epicFilter);
    }
  }
  return newFilterOptions;
}
